// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a1e6f054","845":"43488013"}[chunkId] + ".chunk.js";
};